import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import useAnalytics from "hooks/useAnalytics";
import { ExternalIntegration } from "types/generated";
import TableCellSpace from "ds/components/Table/Row/CellSpace";

const BackstageIntegrationTableSpaceCell = ({
  item: integration,
  ...cellProps
}: TableSimpleCellProps<ExternalIntegration>) => {
  const trackAnalytics = useAnalytics();

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellSpace
        href={`/spaces/${integration.spaceDetails.id}`}
        onPress={() => trackAnalytics("Space link clicked")}
      >
        {integration.spaceDetails.name}
      </TableCellSpace>
    </TableSimpleCell>
  );
};

export default BackstageIntegrationTableSpaceCell;
